import React, { createContext, useState, useEffect } from "react";

const MemberPageContext = createContext();

const MemberPageProvider = ({ children }) => {
    const [localLoginCount, setLocalLoginCount] = useState(0); 

    const updateLoginCount = () => {
        setLocalLoginCount(localLoginCount + 1);
    }

    const loginCount = () => {
        return localLoginCount;
    }
    
    return (
        <MemberPageContext.Provider value={{ loginCount, updateLoginCount }}>
            {children}
        </MemberPageContext.Provider>
    );
}

export { MemberPageProvider };
export default MemberPageContext;